
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import "vue-loading-overlay/dist/vue-loading.css";
import {mapGetters, mapActions, mapMutations, mapState} from "vuex";
import Editor from '@/components/inputs/Editor.vue'

export default {
  name: "DialogesoCohortCreate",
  props: {
    // esoCohort: { type: Object, default: {} },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Editor
  },
  computed: {
    ...mapState("user", ["currentUser"]),
    ...mapState("industry", {industryList: "dataList"}),
    ...mapState("startup-program-category", { programCategoryList: "dataList" }),
    fullName() {
      const first_name = this.currentUser.first_name || "";
      const last_name = this.currentUser.last_name || "";
      return [first_name, last_name].join(" ").trim() || "-";
    },
    dateRangeText() {
      return this.programDisplay.dates?.sort().join(" to ");
    },
    programTypesList(){
      return [
        {id:1, name: this.$i18n.locale === 'km' ? "កម្មវិធីជាតិ":"National", name_km:"ជាតិ", code: "NTL", description: "National Program"},
        {id:2, name: this.$i18n.locale === 'km'  ? "កម្មវិធីអន្តរជាតិ":"International", name_km:"អន្តរជាតិ", code: "GLO", description: "International Program"},
      ]
    },
    esoId() {
      return this.$route.params.esoId;
    },
  },
  mounted() {
    this.fetchProgramCategory();
  },
  created() {
  },
  data() {
    return {
      editorInit: false,
      editorText: "",
      startDate: '',
      endDate: '',
      menuDateRange: false,
      profileImage: null,
      esoCohort: {
      },
      programDisplay: {
        dates: ['','']
      },
      fullPage: true,
      value: [],
      options: [],
      dialog: false,
      imageName: "",
      imageUrl: "",
      imageFile: "",
      editedItem: {},
    };
  },
  async fetch() {
  },
  methods: {
    ...mapActions("eso-program", {
      getProgram: 'get'
    }),
    ...mapActions("eso-cohort", {
      createCohort : 'create'
    }),
    ...mapActions("startup-program-category", { fetchProgramCategory: "get" }),
    editorDetail(value) {
      this.programDisplay.content = value;
    },
    openForm(item) {
      this.esoCohort = this.$common.cloneJSON(item);
      this.dialog = true;
    },

    pickFile() {
      this.$refs.image.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].size > 1000000) {
          const Toast = this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          });
          Toast.fire(this.$t("msg.failed"), "File size must be below 1MB", "error");

          return;
        }
        this.imageName = files[0].name;

        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }


        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {

          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });

      } else {

        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    saveForm() {
      this.saveBasicInfo();
    },
    closeForm() {
      this.dialog = false;
    },
    saveBasicInfo() {
      let valid = this.$refs.formProgramInfo.validate();
      if (!valid) return;
      const formData = new FormData();
      formData.append("eso", this.esoCohort.eso)
      formData.append("program", this.esoCohort.program)

      for (var key in this.programDisplay) {
        if (this.programDisplay[`${key}`] !== "" && this.programDisplay[`${key}`] !== null){
          formData.append(`program_display.${key}`, this.programDisplay[key]);
        }
      }

      if (this.imageFile) formData.append("program_display.image", this.imageFile);
      else delete formData.delete("program_display.image");


      formData.append("program_display.start_date", this.programDisplay.dates[0]);
      formData.append("program_display.end_date", this.programDisplay.dates[1]);


      this.createCohort({payload: formData})
          .then((res) => {
            this.$swal.fire(
                `${this.$t("get_listed.dialog.title.success")}!`,
                `${this.$t("get_listed.dialog.title.success.message")}`,
                "success"
            );
            this.$emit("saved-update");
            this.getProgram({params: {eso: this.esoId}})
            this.closeForm();
          })
          .catch((error) => {
            const message = error.message || error;
            const Toast = this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            });
            Toast.fire(this.$t("msg.failed"), message, "error");
          });
    },
  },
};
